import React from 'react';
import * as R from 'ramda';
// components
import { TextComponent } from '../../../components/text';
// helpers/constants
import * as G from '../../../helpers';
// ui
import { Box, Flex, StickedFlex } from '../../../ui';
// feature audit2
import { getBorderStyles } from '../helpers';
import {
  renderHeader,
  auditDetailsFieldSettings,
} from '../settings/field-settings';
/////////////////////////////////////////////////

const AuditDetails = ({ fields, stickedTop, fieldFontSize }) => (
  <Box ml={115} maxWidth='calc(100% - 115px)' data-testid='testid-auditDetails'>
    <StickedFlex
      pr={30}
      height={32}
      top={R.or(stickedTop, 69)}
      backgroundColor={G.getTheme('colors.bgGrey')}
    >
      {renderHeader(auditDetailsFieldSettings)}
    </StickedFlex>
    {
      fields.map((item, i, arr) => (
        <Flex key={i}>
          {
            G.getNewArrayFromObjectWithHandling(
              (field, key) => (
                <Flex
                  key={key}
                  height={32}
                  minWidth={field.minWidth}
                  width={R.or(field.width, '100%')}
                  borderBottom={getBorderStyles(arr, i)}
                >
                  <TextComponent
                    title={item[key]}
                    withEllipsis={true}
                    fontSize={R.or(fieldFontSize, 14)}
                  >
                    {item[key]}
                  </TextComponent>
                </Flex>
              ),
              auditDetailsFieldSettings,
            )
          }
          <Box
            height={32}
            minWidth={30}
            borderBottom={getBorderStyles(arr, i)}
          />
        </Flex>
      ))
    }
  </Box>
);

export default AuditDetails;
